import ConnectIcon from "../../../assets/images/ConnectIcon.svg";
import CoffeeIcon from "../../../assets/images/CoffeeIcon-.svg";
import FloorPlan from "../../../assets/images/FloorPlan.webp";

function ToursInfoCards() {
  return (
    <div className="leap-flex leap-flex-col eh:leap-flex-row leap-justify-between leap-pt-44 sm:leap-pt-32 leap-pl-8">
      <div className="leap-w-[80%] eh:leap-w-[40%] leap-mx-auto">
        <img
          src={FloorPlan}
          alt="Floor Plan"
          style={{ objectFit: "contain !important" }}
          className="leap-mx-auto leap-rounded-xl leap-pb-20 eh:leap-pb-0 leap-w-[54dvh] map:leap-w-[50dvh] eh:leap-w-[800dvh] "
        />
      </div>
      <div className="leap-flex leap-flex-col leap-my-auto leap-gap-4 eh:leap-w-[60%] leap-mx-auto">
        <div className="leap-p-6 leap-bg-[#191733] leap-rounded-2xl leap-w-[80%] xl:leap-w-[80%] 2xl:leap-w-[70%] leap-mx-auto leap-min-h-40 leap-flex leap-gap-5">
          <div className="leap-my-auto leap-p-5 leap-rounded-full leap-bg-[#842DFF29] leap-border leap-border-solid leap-border-[#842DFF] leap-flex leap-justify-center leap-items-center">
            <img
              src={ConnectIcon}
              alt="Connect Icon"
              className="leap-m-auto leap-w-7 lg:leap-w-6"
              // width={30}
              loading="lazy"
            />
          </div>
          <div className="leap-my-auto">
            <span className="leap-text-[10px] md:leap-text-base 2xl:leap-text-xl leap-text-white leap-font-normal">
              Tours will run from 01:00 PM to 07:45 PM daily.
            </span>
          </div>
        </div>
        <div className="leap-p-6 leap-bg-[#191733] leap-rounded-2xl leap-w-[80%] xl:leap-w-[80%] 2xl:leap-w-[70%] leap-mx-auto leap-min-h-40 leap-flex leap-gap-5">
          <div className="leap-my-auto leap-p-5 leap-rounded-full leap-bg-[#842DFF29] leap-border leap-border-solid leap-border-[#842DFF] leap-flex leap-justify-center leap-items-center">
            <img
              src={ConnectIcon}
              alt="Connect Icon"
              className="leap-m-auto leap-w-8 lg:leap-w-6"
              // width={33}
              loading="lazy"
            />
          </div>
          <div className="leap-my-auto">
            <span className="leap-text-[10px] md:leap-text-base 2xl:leap-text-xl leap-text-white leap-font-normal">
              Please arrive 10 minutes early to complete check in.
            </span>
          </div>
        </div>
        <div className="leap-p-6 leap-bg-[#191733] leap-rounded-2xl leap-w-[80%] xl:leap-w-[80%] 2xl:leap-w-[70%] leap-mx-auto leap-min-h-40 leap-flex leap-gap-5">
          <div className="leap-my-auto leap-p-5 leap-rounded-full leap-bg-[#842DFF29] leap-border leap-border-solid leap-border-[#842DFF] leap-flex leap-justify-center leap-items-center">
            <img
              src={ConnectIcon}
              alt="Connect Icon"
              className="leap-m-auto leap-w-[66px] lg:leap-w-11 xl:leap-w-8 2xl:leap-w-11"
              // width={35}
              loading="lazy"
            />
          </div>
          <div className="leap-my-auto ">
            <span className="leap-text-[10px] md:leap-text-base 2xl:leap-text-xl leap-text-white leap-font-normal">
              Make sure to book your tours in advance. You are welcome to book
              multiple tours per day if you would like.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ToursInfoCards;
